<template>
    <rkm-modal
        :buttons="['cancel']"
        ref="RkmModal"
        title="Agenda do dia"
    >
        <rkm-alert show info>
            <strong>{{dia}} - {{ geralDiaSemanaDescricao }}</strong>
        </rkm-alert>

        <rkm-table
            :fields="fields.tables.diaSelecionado"
            :items="items"
            sort-by="horaInicial"
            hide-filters
            hide-pagination
            hover
            striped
        >
            <template v-slot:cell(dataInicial)="row">
                {{ row.value | formatDateTime }}
            </template>

            <template v-slot:cell(dataFinal)="row">
                {{ row.value | formatDateTime }}
            </template>
        </rkm-table>
    </rkm-modal>
</template>

<script>
// Filters.
import formats from '@/filters/formats'

// Mixins.
import { error, repository } from '@/mixins'

export default {
        computed: {
        fields() {
            return {
                tables: {
                    diaSelecionado: [
                        { key: 'dataInicial', label: 'Inicio',  class: 'col-max', sortable: true },
                        { key: 'dataFinal', label: 'Fim',  class: 'col-max', sortable: true },
                    ],
                },
            }
        },
    },
    filters: {
        formatDateTime: formats.formatDateTime,
    },
    created() {
        this.repositories = {
            jornada: this.getConectaSusRepository('exameImagem.jornada')
        }
    },
    data: () => ({
        items: [],
        dia: null,
        semanaId: null,
        geralDiaSemanaDescricao: '',
    }),
    methods: {
        open(item, diaSelecionado, diaTratado, semanaId) {

            this.item = item
            this.items = diaSelecionado
            this.dia = diaTratado
            this.semanaId = semanaId
            this.geralDiaSemanaDescricao = this.form.diasSemana.find(d => d.id == semanaId).descricao

            this.$refs.RkmModal.show()
        },
    },
      props: {
        model: { type: Object, required: true },
        form: { type: Object, required: true },
    },
    mixins: [ error, repository ],
}
</script>